/* eslint-disable @typescript-eslint/naming-convention */

import React, {FC, useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {SwiperClass} from 'swiper/swiper-react';
import {SwiperOptions} from 'swiper/types';
import 'swiper/css';
import 'swiper/css/pagination';
import style from './style.module.scss';
import {PRODUCT_LIST_VIEW} from 'modules/products/constants';
import {ProductCard} from 'modules/products/components/ProductCard';
import {IProductShort} from 'modules/products/types';
import {PrevButton} from 'components/RecommendationsSlider/PrevButton';
import {NextButton} from 'components/RecommendationsSlider/NextButton';
import {IAnalyticsMeta, TSnippetVersion} from 'core/types';
import {ProductSnippetAnalyticsProvider} from 'modules/analytics/providers/ProductSnippetAnalyticsProvider';

const BREAKPOINTS: Record<number, SwiperOptions> = {
    0: {
        slidesPerView: 2,
        spaceBetween: 0,
    } as SwiperOptions,
    768: {
        slidesPerView: 4,
        spaceBetween: 0,
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 12,
    },
};

interface IProps {
    list: IProductShort[];
    withArrows?: boolean;
    analytics?: IAnalyticsMeta;
    isLoading?: boolean;
    snippetVersion?: TSnippetVersion;
}

export const RecommendationsSlider: FC<IProps> = ({list, withArrows = true, analytics, snippetVersion = 'v2'}) => {
    const [swiper, setSwiper] = useState<SwiperClass>();

    return (
        <ProductSnippetAnalyticsProvider>
            <div className={style.main}>
                <Swiper
                    breakpoints={BREAKPOINTS}
                    onSwiper={setSwiper}
                    touchMoveStopPropagation={false}
                    direction={'horizontal'}
                >
                    {list.map((product, index) => {
                        return (
                            <SwiperSlide className={style.cardContainer} key={`${product.id}-${product.offerId}`}>
                                <ProductCard
                                    tracking={{skipOnViewTracking: false}}
                                    {...product}
                                    analytics={{...analytics, positionIndex: index}}
                                    listType={PRODUCT_LIST_VIEW.tile}
                                    snippetVersion={snippetVersion}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                {withArrows && (
                    <>
                        <PrevButton swiper={swiper} />
                        <NextButton swiper={swiper} />
                    </>
                )}
            </div>
        </ProductSnippetAnalyticsProvider>
    );
};
